// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SiteCreate
 */
export interface SiteCreate {
  /**
   *
   */
  name: string;
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the SiteCreate interface.
 */
export function instanceOfSiteCreate(value: object): value is SiteCreate {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function SiteCreateFromJSON(json: any): SiteCreate {
  return SiteCreateFromJSONTyped(json, false);
}

export function SiteCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    url: json["url"],
  };
}

export function SiteCreateToJSON(json: any): SiteCreate {
  return SiteCreateToJSONTyped(json, false);
}

export function SiteCreateToJSONTyped(
  value?: SiteCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    url: value["url"],
  };
}
